import { render } from "./PacketPage.vue?vue&type=template&id=ed769d88&scoped=true"
import script from "./PacketPage.vue?vue&type=script&lang=js"
export * from "./PacketPage.vue?vue&type=script&lang=js"

import "./PacketPage.vue?vue&type=style&index=0&id=ed769d88&lang=scss&scoped=true"

import exportComponent from "/Users/li/Golang/supergroup.mixin.one/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed769d88"]])

export default __exports__